(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["malika-homepage"] && !Shopify.designMode) return;
  try {
    
  var malikaLanguageSection = document.querySelector('[data-malika-direction]');
  if (malikaLanguageSection) {
    document.documentElement.dir = malikaLanguageSection.getAttribute('data-malika-direction');
  }

  function shuffleMalikaProducts(root) {
    root.querySelectorAll('[data-random-products]').forEach(function (container) {
      var cards = Array.prototype.slice.call(container.children);
      var limit = parseInt(container.getAttribute('data-random-limit'), 10) || cards.length;

      for (var index = cards.length - 1; index > 0; index -= 1) {
        var target = Math.floor(Math.random() * (index + 1));
        var current = cards[index];
        cards[index] = cards[target];
        cards[target] = current;
      }

      cards.forEach(function (card, cardIndex) {
        card.hidden = cardIndex >= limit;
        container.appendChild(card);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      shuffleMalikaProducts(document);
    });
  } else {
    shuffleMalikaProducts(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    shuffleMalikaProducts(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["malika-slideshow"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-malika-slider]').forEach((slider)=>{const slides=[...slider.querySelectorAll('[data-malika-slide]')];const dots=[...slider.querySelectorAll('[data-malika-dot]')];let index=0;let timer;const show=(next)=>{index=(next+slides.length)%slides.length;slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===index));dots.forEach((dot,i)=>{if(i===index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')})};const play=()=>{if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches)timer=window.setInterval(()=>show(index+1),6000)};slider.querySelector('[data-malika-prev]')?.addEventListener('click',()=>{clearInterval(timer);show(index-1);play()});slider.querySelector('[data-malika-next]')?.addEventListener('click',()=>{clearInterval(timer);show(index+1);play()});dots.forEach((dot)=>dot.addEventListener('click',()=>{clearInterval(timer);show(Number(dot.dataset.malikaDot));play()}));play()});

  } catch(e) { console.error(e); }
})();
})();
